import { render } from "./FinalPr.vue?vue&type=template&id=21fafbb2&scoped=true"
import script from "./FinalPr.vue?vue&type=script&lang=js"
export * from "./FinalPr.vue?vue&type=script&lang=js"

import "./FinalPr.vue?vue&type=style&index=0&id=21fafbb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21fafbb2"]])

export default __exports__